import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { ReservationStatusType } from "../models/base/ReservationStatusType";
import { CreateReservationDTO, ReservationConfirmDTO } from "../models/reservation/reservation.request";
import { ReservationClientInfoDTO, ReservationSettingsInfoDTO, ReservationSettingsItemDTO } from "../models/reservation/reservation.response";


export const reservationService = {

    async createReservation(dto: CreateReservationDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/reservations`, dto);
        return data;
    },

    async getUserReservations(userId: string, startDate:Date, endDate:Date, statusType: ReservationStatusType | ""): Promise<ApiResponse<ReservationClientInfoDTO[]>> {
        const { data } = await api.get<ApiResponse<ReservationClientInfoDTO[]>>(`/users/${userId}/reservations`, {
            params: {
                startDate: startDate,
                endDate: endDate,
                statusType: statusType,
            }
        });
        return data;
    },

    async changeStatus(localId: string, id: string, status: ReservationStatusType): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/reservations/${id}/status`, { status });
        return data;
    },

    async cancelReservation(id: string): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/reservations/${id}/cancel`);
        return data;
    },

    async getReservationByLocalId(localId: string): Promise<ApiResponse<ReservationSettingsItemDTO[]>> {
        const { data } = await api.get<ApiResponse<ReservationSettingsItemDTO[]>>(`/locals/${localId}/reservations`);
        return data;
    },

    async getReservationInfoById(localId: string, id: string): Promise<ApiResponse<ReservationSettingsInfoDTO>> {
        const { data } = await api.get<ApiResponse<ReservationSettingsInfoDTO>>(`/locals/${localId}/reservations/${id}/settings`);
        return data;
    },

    async confirmReservation(localId: string, id: string, dto: ReservationConfirmDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/reservations/${id}/confirm`, dto);
        return data;
    }

}